import gql from "graphql-tag"

export default gql`
    query storeLocator1($locale: String!, $preview: Boolean, $url: String) {
        storeLocatorCollection(
            limit: 1
            locale: $locale
            preview: $preview
            where: { slug: $url }
        ) {
            items {
                countriesCollection(limit: 6) {
                    items {
                        ... on RegionSelector {
                            name
                            regionName
                            location {
                                lat
                                lon
                            }
                            subregionsCollection(limit: 16) {
                                items {
                                    ... on RegionSelector {
                                        regionName
                                        stores
                                        location {
                                            lat
                                            lon
                                        }
                                        zoom
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
